import DiscussQuestion from './src/main';

/* istanbul ignore next */
DiscussQuestion.install = function(Vue) {
  Vue.component(DiscussQuestion.name, DiscussQuestion);
};

export default DiscussQuestion;
